module.exports = __webpack_public_path__ + "img/upload-favicon.5d95c4c8.png";